import React from "react";
import { Apartment, Chalet, HotelRoom, Hut } from "./icons";
import { unitTypes } from "@/lib/enums";

const UnitIcon = ({
  type,
  ...props
}: {
  type?: Property["classification"];
} & React.ComponentProps<"svg">) => {
  switch (type) {
    case unitTypes.resort:
    case unitTypes.room:
      return <HotelRoom {...props} />;
    case unitTypes.hut:
      return <Hut {...props} />;
    case unitTypes.apartment:
      return <Apartment {...props} />;
    case unitTypes.chalet:
      return <Chalet {...props} />;
    default:
      return <Apartment {...props} />;
  }
};

export default UnitIcon;
